import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';

@MergeSchema()
export class LeadContactMergeData {

    @MergeField()
    firstName: string;

    @MergeField()
    lastName: string;

    @MergeField()
    name: string;

    @MergeField()
    email: string;

    @MergeField()
    mobile: string;

    @MergeField()
    workPhone: string;

    @MergeField()
    jobTitle: string;
}

export const LeadContactMergeSchema = getSchema(LeadContactMergeData);